module.exports = __webpack_public_path__ + "img/beta.d09ba341.svg";